import { get, post, put, del } from "../request";

const PREFIX = "/contentAdmin/bannerAdmin";

/** 分页查询广告 */
export function getBannerList(params) {
  return get(`${PREFIX}/list`, params);
}

/** 新增广告 */
export function addBanner(data) {
  return post(PREFIX, data);
}

/** 修改广告 */
export function updateBanner(data) {
  return put(PREFIX, data);
}

/** 删除广告 */
export function deleteBanner(ids) {
  return del(`${PREFIX}/${ids}`);
}



// WEBPACK FOOTER //
// ./src/api/content/banner.js